import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import { Input, BodyText, Dropdown } from "../../elements";
import "./style.scss";
import { isBizNull } from "../../utils";
import { isEmptyObject, isGlobalSite } from "../../utils/siteUtils";
import { addressTypes } from "../../utils/lynkco-constants";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import getSiteInfo from "../../utils/getSiteInfo";

const MyAddressItem = React.forwardRef((props, ref) => {
  const { streetLabel, streetMissingMessage, apartmentLabel, postalCodeLabel, postalCodeMissingMessage, cityLabel, cityMissingMessage, countryLabel, countryMissingMessage, addressItemFields, address, countries, label, isSelectedOption, user } = props;
  // const { countryPrivateImportMessage } = addressItemFields;
  const [street, setStreet] = useState(null);
  const [streetError, setStreetError] = useState(null);
  const [apartment, setApartment] = useState(null);
  const [apartmentError, setApartmentError] = useState(null);
  const [postalCode, setPostalCode] = useState(null);
  const [postalCodeError, setPostalCodeError] = useState(null);
  const [city, setCity] = useState(null);
  const [cityError, setCityError] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [serverError, setServerError] = useState(null);
  const [countryPrivateImportMsgShow, setCountryPrivateImportMsgShow] = useState(false);

  const onAutocompleteLocation = address => {
    if (address.street) setStreet(address.street);
    setCity(address.city ? address.city : "");
    setPostalCode(address.postalCode ? address.postalCode : "");

    if (address.country && countries) {
      const filteredCountry = countries.filter(c => c.data.regionAbbr === address.country);
      if (filteredCountry && filteredCountry.length) {
        setSelectedCountry(filteredCountry[0]);
      }
    }
  };

  useEffect(() => {
    if (!isEmptyObject(address)) {
      const { street, apartment, postalCode, city, country } = address;
      setStreet(street);
      setApartment(apartment);
      setPostalCode(postalCode);
      setCity(city);
      setSelectedCountry(country);
    }
  }, [address]);

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      let isValid = true;
      if (isBizNull(street)) {
        setStreetError(streetMissingMessage?.value || "something wrong");
        isValid = false;
      }
      if (isBizNull(postalCode)) {
        setPostalCodeError(postalCodeMissingMessage?.value || "something wrong");
        isValid = false;
      }
      if (isBizNull(city)) {
        setCityError(cityMissingMessage?.value || "something wrong");
        isValid = false;
      }
      if (isBizNull(selectedCountry)) {
        setCountryError(countryMissingMessage?.value || "something wrong");
        isValid = false;
      }
      const data = {
        addressId: address?.addressId,
        firstName: user?.firstName,
        lastName: user?.lastName,
        // mobile: "string",
        // mobileCountryCode: "string",
        countryCode: selectedCountry?.data.regionAbbr,
        countryId: selectedCountry?.code.toString(),
        country: selectedCountry?.value,
        // province: "string",
        city: city,
        street: street,
        apartment: apartment,
        postalCode: postalCode,
        defaultFlag: "1",
        addressType: addressTypes.shipping
      };
      return { isValid, data };
    }
  }));
  const streetProps = {
    value: street,
    label: streetLabel.value,
    placeholder: "",
    showError: !!streetError,
    warningMessage: streetError,
    location: { onAutocomplete: onAutocompleteLocation },
    onFocus: evt => {
      setStreetError(null);
    },
    onChange: evt => {
      setStreet(evt.target.value);
    }
  };
  const apartmentProps = {
    value: apartment,
    label: apartmentLabel.value,
    showError: !!apartmentError,
    warningMessage: apartmentError,
    onFocus: evt => {
      setApartmentError(null);
    },
    onChange: evt => {
      setApartment(evt.target.value);
    }
  };
  const postalCodeProps = {
    value: postalCode,
    label: postalCodeLabel.value,
    showError: !!postalCodeError,
    warningMessage: postalCodeError,
    onFocus: evt => {
      setPostalCodeError(null);
    },
    onChange: evt => {
      setPostalCode(evt.target.value);
    }
  };
  const cityProps = {
    value: city,
    label: cityLabel.value,
    showError: !!cityError,
    warningMessage: cityError,
    onFocus: evt => {
      setCityError(null);
    },
    onChange: evt => {
      setCity(evt.target.value);
    }
  };
  const countryProps = {
    selectedOption: selectedCountry,
    options: countries,
    placeholder: countryLabel.value,
    showError: !!countryError,
    warningMessage: countryError,
    onFocus: evt => {
      setCountryError(null);
    },
    onChange: async option => {
      setSelectedCountry(option);
      const siteInfo = await getSiteInfo();
      if (!isGlobalSite()) {
        if (option.code !== siteInfo.country) {
          setCountryPrivateImportMsgShow(true);
        } else {
          setCountryPrivateImportMsgShow(false);
        }
      } else {
        setCountryPrivateImportMsgShow(false);
      }
    }
  };

  return (
    <div className="address-container-my-account">
      <div className="label-container">
        <span className="label">{label.value}</span>
      </div>
      {isSelectedOption && (
        <div className="address_">
          {/*<Input {...firstNameProps} />*/}
          {/*<Input {...lastNameProps} />*/}
          <Input {...streetProps} />
          <Input {...apartmentProps} />
          <div className="my-account-personal-information-input-group">
            <Input className={"zip-input"} {...postalCodeProps} />
            <Input className={"city-input"} {...cityProps} />
          </div>
          <Dropdown {...countryProps} />
          {/*{countryPrivateImportMsgShow && <div className="private-import-message">{countryPrivateImportMessage.value}</div>}*/}
          {serverError && <BodyText className="failed-message" html={serverError} />}
        </div>
      )}
    </div>
  );
});
const mapStateToProps = state => ({
  user: selectUserState(state)
});
MyAddressItem.displayName = "MyAddressItem";
export default connect(mapStateToProps, null, null, { forwardRef: true })(MyAddressItem);
